import { BaseApiClient } from '../baseApiClient';

class MeterApiKeysApiClient extends BaseApiClient {
  constructor() {
    super('inventory-meter-api-keys');
  }

  public async generate(count: number): Promise<{ apiKeys: string[] }> {
    const response = await this.axios.post<{ apiKeys: string[] }>('/generate', { count });
    return response.data;
  }
}

let client: MeterApiKeysApiClient;

/**
 * @deprecated Create instance in `src\containers\services\Provider.tsx` and use it via `useServices` hook.
 */
export const getMeterApiKeysApiClient = (): MeterApiKeysApiClient => client ?? (client = new MeterApiKeysApiClient());
